import React from "react";
import { useSelector } from "react-redux";

import { SideNavBarV2 } from "../../components";
import { getUserPermissions } from "../../redux/auth";
import { PERMISSION_LEVEL_KEYS } from "../../constants/permissions";
import { tabs } from "./helper";

const OrganizationNav = ({ value = 1, setValue = () => {} }) => {
  const permissions = useSelector(getUserPermissions);

  const visibleTabs = tabs.filter((tab) => {
    if (!tab.permission) return true;
    const userPerm = permissions?.find((p) => p.id === tab.permission);
    return (userPerm?.value ?? 0) >= PERMISSION_LEVEL_KEYS.VIEW_ONLY;
  });

  return <SideNavBarV2 tabs={visibleTabs} value={value} setValue={setValue} />;
};

export default OrganizationNav;
